import { render, staticRenderFns } from "./SynchronizeStatus.vue?vue&type=template&id=2a4f40fc"
import script from "./SynchronizeStatus.vue?vue&type=script&lang=ts"
export * from "./SynchronizeStatus.vue?vue&type=script&lang=ts"
import style0 from "./SynchronizeStatus.vue?vue&type=style&index=0&id=2a4f40fc&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports